export const Logo = () => (
  <svg
    width="156"
    height="45"
    viewBox="0 0 156 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="23.3777"
      cy="23.0926"
      r="21.0926"
      fill="url(#paint0_linear_22_26737)"
    />
    <path
      d="M38.2821 29.5699V16.1751C38.2821 14.0664 36.6027 12.3569 34.531 12.3569C32.4592 12.3569 30.7798 14.0664 30.7798 16.1751V25.2835C31.1341 24.9408 31.604 24.6562 32.0666 24.817C32.3133 24.9028 32.5332 25.069 32.6338 25.3619C32.7929 25.8254 32.5408 26.3146 32.3154 26.7487L31.2769 28.7485C31.228 28.8424 31.1669 28.9292 31.0952 29.0065C30.8926 29.2245 30.7798 29.5131 30.7798 29.8132V30.4966C30.7798 32.0935 32.0516 33.3881 33.6205 33.3881H34.531C36.6027 33.3881 38.2821 31.6786 38.2821 29.5699Z"
      fill="#9FF9E8"
    />
    <path
      d="M24.7528 29.6986V16.0468C24.7528 13.9411 23.0458 12.2341 20.9401 12.2341C18.8344 12.2341 17.1274 13.9411 17.1274 16.0468V25.3119C17.4874 24.9653 17.968 24.6763 18.4396 24.8415C18.6923 24.93 18.9168 25.1016 19.0163 25.4044C19.1684 25.8674 18.9193 26.3514 18.6938 26.7835L17.6327 28.8173C17.5831 28.9124 17.5208 29.0004 17.4476 29.0789C17.2419 29.2993 17.1274 29.5895 17.1274 29.891V30.578C17.1274 32.198 18.4407 33.5113 20.0607 33.5113H20.9401C23.0458 33.5113 24.7528 31.8043 24.7528 29.6986Z"
      fill="#849EFE"
    />
    <path
      d="M37.9077 20.8459C39.4117 19.342 41.8408 19.3327 43.3333 20.8252C44.8258 22.3178 44.8165 24.7469 43.3126 26.2508L37.055 32.5084C35.551 34.0124 33.1219 34.0216 31.6294 32.5291C30.1369 31.0366 30.1462 28.6075 31.6501 27.1036L37.9077 20.8459Z"
      fill="#10EAED"
    />
    <path
      d="M18.2853 13.3849C19.7716 11.8985 22.1815 11.8985 23.6679 13.3849C25.1542 14.8712 25.1542 17.2811 23.6678 18.7675L10.074 32.3613C8.58764 33.8477 6.17778 33.8477 4.69142 32.3613C3.20506 30.875 3.20506 28.4651 4.69142 26.9787L18.2853 13.3849Z"
      fill="url(#paint1_linear_22_26737)"
    />
    <g filter="url(#filter0_bd_22_26737)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8665 13.7449C17.4019 14.3766 17.1274 15.1569 17.1274 16.0012V25.27C17.1346 25.2631 17.1417 25.2563 17.149 25.2495L23.652 18.7446C24.3075 18.0889 24.6744 17.2538 24.7528 16.3973V16.0012C24.7528 15.5794 24.6843 15.1736 24.5578 14.7942C24.3748 14.2671 24.0729 13.7722 23.652 13.3511C22.1631 11.8618 19.749 11.8618 18.2601 13.3511L17.8665 13.7449Z"
        fill="url(#paint2_linear_22_26737)"
      />
    </g>
    <path
      d="M31.7023 13.5258C33.2307 11.9973 35.7088 11.9973 37.2372 13.5258C38.7656 15.0542 38.7656 17.5323 37.2372 19.0607L23.5736 32.7242C22.0452 34.2527 19.5671 34.2527 18.0387 32.7242C16.5103 31.1958 16.5103 28.7177 18.0387 27.1893L31.7023 13.5258Z"
      fill="url(#paint3_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9726 32.344C24.4627 31.6878 24.7529 30.8734 24.7529 29.9913V20.4753C24.7456 20.4824 24.7382 20.4894 24.7308 20.4964L18.0179 27.1854C17.3412 27.8597 16.9625 28.7184 16.8816 29.5991V29.9913C16.8816 30.535 16.9918 31.0528 17.1912 31.5239C17.3825 31.9623 17.6581 32.373 18.0179 32.7315C19.5549 34.263 22.0468 34.263 23.5837 32.7315L23.9726 32.344Z"
      fill="url(#paint4_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5181 32.1105C37.9984 31.4723 38.2822 30.6838 38.2822 29.8306V20.4755C38.2748 20.4824 38.2674 20.4894 38.2599 20.4963L31.5472 27.0624C30.8705 27.7243 30.4918 28.5672 30.4109 29.4318V29.8306C30.4109 30.2635 30.484 30.6798 30.6187 31.0682C30.8082 31.5935 31.1177 32.0866 31.5472 32.5067C33.0842 34.0101 35.5761 34.0101 37.113 32.5067L37.5181 32.1105Z"
      fill="url(#paint5_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.396 13.9079C30.931 14.547 30.6567 15.3338 30.6567 16.1847V25.6387C30.664 25.6317 30.6713 25.6248 30.6786 25.6178L37.2865 18.9902C37.9526 18.3222 38.3255 17.4713 38.4051 16.5987V16.1847C38.4051 15.8178 38.3541 15.4628 38.2588 15.1265C38.0808 14.5293 37.7568 13.9666 37.2865 13.495C35.7736 11.9776 33.3206 11.9776 31.8077 13.495L31.396 13.9079Z"
      fill="url(#paint6_linear_22_26737)"
    />
    <path
      d="M70.3 18.896C71.1926 18.896 72.0021 19.0518 72.7287 19.3635C73.476 19.6751 74.1091 20.1218 74.6281 20.7035C75.147 21.2852 75.5518 21.9812 75.8424 22.7915C76.133 23.581 76.2783 24.4744 76.2783 25.4716V35.1637H72.7598V26.0014C72.7598 24.7964 72.4692 23.8511 71.888 23.1655C71.3067 22.4799 70.4868 22.1371 69.4281 22.1371C68.4317 22.1371 67.6325 22.4487 67.0305 23.072C66.4285 23.6953 66.0757 24.4848 65.9719 25.4405V25.534V35.1637H62.4533V26.0014C62.4533 24.7964 62.1523 23.8511 61.5504 23.1655C60.9691 22.4799 60.2011 22.1371 59.2462 22.1371C58.1252 22.1371 57.2326 22.511 56.5684 23.259C55.9249 23.9861 55.6031 24.9107 55.6031 26.0326V35.1637H52.1157V19.1765H55.4163V21.2956C55.8314 20.5892 56.4023 20.0179 57.1288 19.5816C57.8761 19.1245 58.8414 18.896 60.0246 18.896C61.1456 18.896 62.142 19.1453 63.0138 19.6439C63.8857 20.1426 64.5811 20.8593 65.1 21.7943C65.5775 20.9632 66.2417 20.2776 67.0928 19.7374C67.9647 19.1765 69.0337 18.896 70.3 18.896Z"
      fill="#1A3842"
    />
    <path
      d="M86.4496 18.896C88.5254 18.896 90.103 19.4362 91.1825 20.5165C92.2826 21.5969 92.8327 23.1655 92.8327 25.2223V35.1637H89.3142V33.7301C88.7537 34.2703 88.1102 34.6962 87.3837 35.0079C86.6779 35.3195 85.8787 35.4753 84.9861 35.4753C83.3877 35.4753 82.1007 35.0702 81.1251 34.2599C80.1494 33.4496 79.6616 32.2966 79.6616 30.8007C79.6616 29.9489 79.8069 29.2321 80.0975 28.6504C80.4089 28.0479 80.8241 27.5596 81.343 27.1857C81.8828 26.7909 82.5055 26.5 83.2113 26.3131C83.9378 26.1261 84.7059 26.0118 85.5155 25.9703L89.3142 25.7521V25.2846C89.3142 24.2458 89.0859 23.4356 88.6292 22.8538C88.1933 22.2513 87.4771 21.9501 86.4807 21.9501C85.4843 21.9501 84.7578 22.2202 84.3011 22.7603C83.8444 23.3005 83.6161 23.9342 83.6161 24.6614L80.0975 24.5367C80.0975 23.8303 80.2428 23.1447 80.5335 22.4799C80.8241 21.7943 81.2392 21.1918 81.779 20.6724C82.3187 20.1322 82.9829 19.7063 83.7718 19.3946C84.5606 19.0622 85.4532 18.896 86.4496 18.896ZM86.0136 28.6815C85.1833 28.7231 84.4983 28.8997 83.9586 29.2113C83.4396 29.5022 83.1801 30.0112 83.1801 30.7384C83.1801 31.4032 83.3981 31.8707 83.834 32.1408C84.2907 32.4108 84.8719 32.5459 85.5777 32.5459C86.6987 32.5459 87.6017 32.2654 88.2867 31.7045C88.9925 31.1435 89.3453 30.2501 89.3453 29.0243V28.4634L86.0136 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M101.012 20.9841C101.385 20.4231 101.946 19.9349 102.693 19.5194C103.441 19.1038 104.375 18.8961 105.496 18.8961C106.409 18.8961 107.239 19.0519 107.987 19.3635C108.755 19.6544 109.409 20.0907 109.948 20.6724C110.509 21.2334 110.945 21.9294 111.256 22.7604C111.567 23.5707 111.723 24.4952 111.723 25.534V35.1637H108.205V26.0015C108.205 24.7965 107.883 23.8512 107.239 23.1656C106.617 22.4799 105.776 22.1371 104.717 22.1371C103.596 22.1371 102.693 22.5111 102.008 23.2591C101.344 23.9862 101.012 24.9108 101.012 26.0327V35.1637H97.5244V10.9492H101.012V20.9841Z"
      fill="#1A3842"
    />
    <path
      d="M121.48 18.896C123.556 18.896 125.133 19.4362 126.213 20.5165C127.313 21.5969 127.863 23.1655 127.863 25.2223V35.1637H124.344V33.7301C123.784 34.2703 123.141 34.6962 122.414 35.0079C121.708 35.3195 120.909 35.4753 120.016 35.4753C118.418 35.4753 117.131 35.0702 116.155 34.2599C115.18 33.4496 114.692 32.2966 114.692 30.8007C114.692 29.9489 114.837 29.2321 115.128 28.6504C115.439 28.0479 115.854 27.5596 116.373 27.1857C116.913 26.7909 117.536 26.5 118.242 26.3131C118.968 26.1261 119.736 26.0118 120.546 25.9703L124.344 25.7521V25.2846C124.344 24.2458 124.116 23.4356 123.659 22.8538C123.224 22.2513 122.507 21.9501 121.511 21.9501C120.515 21.9501 119.788 22.2202 119.331 22.7603C118.875 23.3005 118.646 23.9342 118.646 24.6614L115.128 24.5367C115.128 23.8303 115.273 23.1447 115.564 22.4799C115.854 21.7943 116.27 21.1918 116.809 20.6724C117.349 20.1322 118.013 19.7063 118.802 19.3946C119.591 19.0622 120.483 18.896 121.48 18.896ZM121.044 28.6815C120.214 28.7231 119.529 28.8997 118.989 29.2113C118.47 29.5022 118.21 30.0112 118.21 30.7384C118.21 31.4032 118.428 31.8707 118.864 32.1408C119.321 32.4108 119.902 32.5459 120.608 32.5459C121.729 32.5459 122.632 32.2654 123.317 31.7045C124.023 31.1435 124.376 30.2501 124.376 29.0243V28.4634L121.044 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M132.554 35.1637V10.9492H136.041V35.1637H132.554Z"
      fill="#1A3842"
    />
    <path
      d="M147.687 18.896C148.87 18.896 149.971 19.0934 150.988 19.4881C152.005 19.8621 152.877 20.4127 153.603 21.1398C154.351 21.8462 154.932 22.7188 155.347 23.7576C155.783 24.7756 156.001 25.9183 156.001 27.1857C156.001 28.453 155.783 29.5957 155.347 30.6137C154.932 31.6317 154.351 32.5043 153.603 33.2315C152.877 33.9379 152.005 34.4885 150.988 34.8832C149.971 35.2779 148.87 35.4753 147.687 35.4753C146.504 35.4753 145.404 35.2779 144.387 34.8832C143.369 34.4885 142.487 33.9379 141.74 33.2315C140.993 32.5043 140.401 31.6317 139.965 30.6137C139.55 29.5957 139.342 28.453 139.342 27.1857C139.342 25.9183 139.55 24.7756 139.965 23.7576C140.401 22.7188 140.993 21.8462 141.74 21.1398C142.487 20.4127 143.369 19.8621 144.387 19.4881C145.404 19.0934 146.504 18.896 147.687 18.896ZM147.687 21.8878C146.296 21.8878 145.144 22.3552 144.231 23.2901C143.338 24.2043 142.892 25.5028 142.892 27.1857C142.892 28.8477 143.338 30.1462 144.231 31.0812C145.144 31.9953 146.296 32.4524 147.687 32.4524C148.372 32.4524 149.005 32.3381 149.586 32.1096C150.168 31.8603 150.676 31.5175 151.112 31.0812C151.548 30.6241 151.88 30.0735 152.109 29.4295C152.358 28.7646 152.482 28.0167 152.482 27.1857C152.482 26.3546 152.358 25.6171 152.109 24.973C151.88 24.3082 151.548 23.7472 151.112 23.2901C150.676 22.8331 150.168 22.4903 149.586 22.2617C149.005 22.0124 148.372 21.8878 147.687 21.8878Z"
      fill="#1A3842"
    />
    <defs>
      <filter
        id="filter0_bd_22_26737"
        x="-146.873"
        y="-151.766"
        width="335.625"
        height="341.036"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_22_26737"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_22_26737"
          result="effect2_dropShadow_22_26737"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_22_26737"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_22_26737"
        x1="9.76732"
        y1="39.6246"
        x2="39.6247"
        y2="9.69594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_22_26737"
        x1="22.969"
        y1="12.8426"
        x2="4.69804"
        y2="32.3675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_22_26737"
        x1="20.9401"
        y1="12.2341"
        x2="17.1255"
        y2="24.1053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_22_26737"
        x1="33.4783"
        y1="15.9791"
        x2="21.7729"
        y2="29.0031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_22_26737"
        x1="18.788"
        y1="26.5449"
        x2="24.891"
        y2="31.5622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_22_26737"
        x1="34.3466"
        y1="33.6343"
        x2="37.6969"
        y2="20.934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_22_26737"
        x1="34.5309"
        y1="12.3569"
        x2="30.6356"
        y2="25.0103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const MahaloCareLogo = () => (
  <svg
    width="156"
    height="43"
    viewBox="0 0 156 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M43.0221 21.3663C43.0221 33.1666 33.456 42.7326 21.6557 42.7326C9.85546 42.7326 0.289429 33.1666 0.289429 21.3663C0.289429 9.56603 9.85546 0 21.6557 0C33.456 0 43.0221 9.56603 43.0221 21.3663Z"
      fill="url(#paint0_linear_97_39825)"
    />
    <path
      d="M36.7564 27.9286V14.3599C36.7564 12.2238 35.0552 10.4922 32.9566 10.4922C30.858 10.4922 29.1567 12.2238 29.1567 14.3599V23.5865C29.5156 23.2394 29.9917 22.9511 30.4602 23.114C30.7101 23.2009 30.9329 23.3693 31.0348 23.6659C31.196 24.1355 30.9406 24.631 30.7123 25.0707L29.6603 27.0965C29.6108 27.1917 29.5489 27.2796 29.4762 27.3578C29.2711 27.5787 29.1567 27.8711 29.1567 28.175V28.8673C29.1567 30.4849 30.4451 31.7963 32.0344 31.7963H32.9566C35.0552 31.7963 36.7564 30.0647 36.7564 27.9286Z"
      fill="#C3B8FF"
    />
    <path
      d="M23.0518 28.0583V14.2293C23.0518 12.0963 21.3227 10.3672 19.1897 10.3672C17.0567 10.3672 15.3275 12.0963 15.3275 14.2293V23.6147C15.6922 23.2636 16.179 22.9708 16.6567 23.1381C16.9127 23.2278 17.1401 23.4017 17.2409 23.7084C17.3949 24.1774 17.1426 24.6677 16.9142 25.1054L15.8393 27.1656C15.7891 27.262 15.726 27.3511 15.6518 27.4306C15.4434 27.6538 15.3275 27.9479 15.3275 28.2533V28.9492C15.3275 30.5902 16.6578 31.9205 18.2988 31.9205H19.1897C21.3227 31.9205 23.0518 30.1913 23.0518 28.0583Z"
      fill="#C3B8FF"
    />
    <path
      d="M36.3747 19.0866C37.8982 17.5631 40.3588 17.5538 41.8707 19.0656V19.0656C43.3826 20.5775 43.3732 23.0382 41.8497 24.5616L35.5109 30.9005C33.9874 32.4239 31.5268 32.4333 30.0149 30.9214V30.9214C28.503 29.4095 28.5124 26.9489 30.0359 25.4254L36.3747 19.0866Z"
      fill="url(#paint1_linear_97_39825)"
    />
    <path
      d="M16.4966 11.5309C18.0022 10.0253 20.4433 10.0253 21.949 11.5309V11.5309C23.4546 13.0366 23.4546 15.4777 21.949 16.9833L8.17871 30.7536C6.67306 32.2593 4.23192 32.2593 2.72627 30.7536V30.7536C1.22062 29.248 1.22062 26.8068 2.72627 25.3012L16.4966 11.5309Z"
      fill="url(#paint2_linear_97_39825)"
    />
    <path
      d="M30.0883 11.6706C31.6366 10.1223 34.1468 10.1223 35.6951 11.6706V11.6706C37.2434 13.2188 37.2434 15.7291 35.6951 17.2773L21.8542 31.1182C20.306 32.6665 17.7957 32.6665 16.2475 31.1182V31.1182C14.6992 29.57 14.6992 27.0597 16.2475 25.5115L30.0883 11.6706Z"
      fill="url(#paint3_linear_97_39825)"
    />
    <path
      d="M69.1872 9.85938C70.0914 9.85938 70.9115 10.0172 71.6475 10.3329C72.4045 10.6486 73.0458 11.1011 73.5715 11.6904C74.0972 12.2796 74.5072 12.9847 74.8016 13.8055C75.096 14.6052 75.2432 15.5102 75.2432 16.5203V26.3382H71.679V17.057C71.679 15.8364 71.3846 14.8788 70.7958 14.1843C70.2071 13.4898 69.3765 13.1425 68.3041 13.1425C67.2947 13.1425 66.4852 13.4582 65.8754 14.0896C65.2656 14.7209 64.9081 15.5207 64.8029 16.4888V16.5835V26.3382H61.2388V17.057C61.2388 15.8364 60.9338 14.8788 60.324 14.1843C59.7353 13.4898 58.9573 13.1425 57.99 13.1425C56.8545 13.1425 55.9503 13.5213 55.2774 14.279C54.6255 15.0156 54.2996 15.9521 54.2996 17.0886V26.3382H50.767V10.1435H54.1104V12.2902C54.5309 11.5746 55.1092 10.9958 55.8452 10.5539C56.6021 10.0909 57.5799 9.85938 58.7785 9.85938C59.914 9.85938 60.9233 10.1119 61.8065 10.617C62.6897 11.1221 63.3941 11.8482 63.9198 12.7953C64.4034 11.9534 65.0763 11.2589 65.9384 10.7117C66.8216 10.1435 67.9045 9.85938 69.1872 9.85938Z"
      fill="#212121"
    />
    <path
      d="M85.5473 9.85938C87.6501 9.85938 89.2482 10.4066 90.3416 11.5009C91.4561 12.5953 92.0133 14.1843 92.0133 16.2678V26.3382H88.4491V24.886C87.8814 25.4332 87.2295 25.8647 86.4936 26.1803C85.7786 26.496 84.969 26.6539 84.0649 26.6539C82.4457 26.6539 81.142 26.2435 80.1537 25.4227C79.1654 24.6019 78.6713 23.4339 78.6713 21.9186C78.6713 21.0557 78.8185 20.3296 79.1128 19.7403C79.4283 19.13 79.8488 18.6354 80.3745 18.2566C80.9212 17.8568 81.5521 17.5621 82.267 17.3727C83.003 17.1833 83.781 17.0675 84.6011 17.0254L88.4491 16.8045V16.3309C88.4491 15.2787 88.2178 14.4579 87.7552 13.8686C87.3136 13.2583 86.5882 12.9531 85.5789 12.9531C84.5695 12.9531 83.8336 13.2267 83.3709 13.7739C82.9083 14.3211 82.677 14.963 82.677 15.6996L79.1128 15.5733C79.1128 14.8577 79.26 14.1632 79.5544 13.4898C79.8488 12.7953 80.2694 12.1849 80.8161 11.6588C81.3628 11.1116 82.0357 10.6802 82.8347 10.3645C83.6338 10.0277 84.538 9.85938 85.5473 9.85938ZM85.1057 19.7719C84.2646 19.814 83.5707 19.9929 83.024 20.3086C82.4983 20.6032 82.2355 21.1188 82.2355 21.8554C82.2355 22.5289 82.4562 23.0024 82.8978 23.276C83.3604 23.5496 83.9492 23.6864 84.6641 23.6864C85.7996 23.6864 86.7143 23.4023 87.4083 22.8341C88.1232 22.2658 88.4807 21.3609 88.4807 20.1192V19.5509L85.1057 19.7719Z"
      fill="#212121"
    />
    <path
      d="M100.297 11.9776C100.675 11.4094 101.243 10.9148 102 10.4939C102.757 10.073 103.703 9.8625 104.839 9.8625C105.764 9.8625 106.605 10.0203 107.362 10.336C108.14 10.6307 108.802 11.0726 109.349 11.6619C109.917 12.2301 110.358 12.9352 110.674 13.777C110.989 14.5978 111.147 15.5343 111.147 16.5866V26.3413H107.583V17.0601C107.583 15.8395 107.257 14.8819 106.605 14.1874C105.974 13.4929 105.122 13.1456 104.05 13.1456C102.915 13.1456 102 13.5245 101.306 14.2821C100.633 15.0187 100.297 15.9552 100.297 17.0917V26.3413H96.7639V1.8125H100.297V11.9776Z"
      fill="#212121"
    />
    <path
      d="M121.029 9.85938C123.132 9.85938 124.73 10.4066 125.823 11.5009C126.938 12.5953 127.495 14.1843 127.495 16.2678V26.3382H123.931V24.886C123.363 25.4332 122.711 25.8647 121.975 26.1803C121.26 26.496 120.451 26.6539 119.547 26.6539C117.928 26.6539 116.624 26.2435 115.636 25.4227C114.647 24.6019 114.153 23.4339 114.153 21.9186C114.153 21.0557 114.3 20.3296 114.595 19.7403C114.91 19.13 115.331 18.6354 115.856 18.2566C116.403 17.8568 117.034 17.5621 117.749 17.3727C118.485 17.1833 119.263 17.0675 120.083 17.0254L123.931 16.8045V16.3309C123.931 15.2787 123.7 14.4579 123.237 13.8686C122.795 13.2583 122.07 12.9531 121.061 12.9531C120.051 12.9531 119.315 13.2267 118.853 13.7739C118.39 14.3211 118.159 14.963 118.159 15.6996L114.595 15.5733C114.595 14.8577 114.742 14.1632 115.036 13.4898C115.331 12.7953 115.751 12.1849 116.298 11.6588C116.845 11.1116 117.518 10.6802 118.317 10.3645C119.116 10.0277 120.02 9.85938 121.029 9.85938ZM120.588 19.7719C119.746 19.814 119.053 19.9929 118.506 20.3086C117.98 20.6032 117.717 21.1188 117.717 21.8554C117.717 22.5289 117.938 23.0024 118.38 23.276C118.842 23.5496 119.431 23.6864 120.146 23.6864C121.281 23.6864 122.196 23.4023 122.89 22.8341C123.605 22.2658 123.962 21.3609 123.962 20.1192V19.5509L120.588 19.7719Z"
      fill="#212121"
    />
    <path d="M132.251 26.3413V1.8125H135.784V26.3413H132.251Z" fill="#212121" />
    <path
      d="M147.578 9.85938C148.777 9.85938 149.891 10.0593 150.922 10.4592C151.952 10.838 152.835 11.3957 153.571 12.1323C154.328 12.8479 154.917 13.7318 155.338 14.7841C155.779 15.8153 156 16.9728 156 18.2566C156 19.5404 155.779 20.6979 155.338 21.7292C154.917 22.7604 154.328 23.6443 153.571 24.3809C152.835 25.0965 151.952 25.6542 150.922 26.0541C149.891 26.4539 148.777 26.6539 147.578 26.6539C146.38 26.6539 145.265 26.4539 144.235 26.0541C143.205 25.6542 142.311 25.0965 141.554 24.3809C140.797 23.6443 140.198 22.7604 139.756 21.7292C139.336 20.6979 139.125 19.5404 139.125 18.2566C139.125 16.9728 139.336 15.8153 139.756 14.7841C140.198 13.7318 140.797 12.8479 141.554 12.1323C142.311 11.3957 143.205 10.838 144.235 10.4592C145.265 10.0593 146.38 9.85938 147.578 9.85938ZM147.578 12.89C146.17 12.89 145.002 13.3635 144.077 14.3105C143.173 15.2366 142.721 16.5519 142.721 18.2566C142.721 19.9403 143.173 21.2556 144.077 22.2027C145.002 23.1287 146.17 23.5917 147.578 23.5917C148.272 23.5917 148.914 23.476 149.502 23.2445C150.091 22.9919 150.606 22.6447 151.048 22.2027C151.49 21.7397 151.826 21.182 152.057 20.5296C152.31 19.8561 152.436 19.0985 152.436 18.2566C152.436 17.4148 152.31 16.6677 152.057 16.0153C151.826 15.3418 151.49 14.7736 151.048 14.3105C150.606 13.8475 150.091 13.5003 149.502 13.2688C148.914 13.0162 148.272 12.89 147.578 12.89Z"
      fill="#212121"
    />
    <path
      d="M150.412 38.0749V30.8359H155.207V32.0851H151.927V33.8309H155.022V34.9947H151.927V36.8258H155.207V38.0749H150.412Z"
      fill="url(#paint4_linear_97_39825)"
    />
    <path
      d="M138.86 38.0749V30.8359H141.875C142.424 30.8359 142.89 30.9296 143.275 31.1169C143.663 31.3008 143.957 31.565 144.158 31.9095C144.362 32.254 144.464 32.6637 144.464 33.1386V33.1486C144.464 33.6135 144.348 34.0315 144.118 34.4027C143.89 34.7706 143.569 35.0365 143.154 35.2004L144.679 38.0749H142.964L141.614 35.4261C141.604 35.4261 141.592 35.4261 141.579 35.4261C141.566 35.4261 141.554 35.4261 141.544 35.4261H140.375V38.0749H138.86ZM140.375 34.3225H141.71C142.087 34.3225 142.382 34.2221 142.592 34.0215C142.807 33.8175 142.914 33.5365 142.914 33.1787V33.1687C142.914 32.8175 142.805 32.5382 142.587 32.3309C142.37 32.1235 142.071 32.0199 141.689 32.0199H140.375V34.3225Z"
      fill="url(#paint5_linear_97_39825)"
    />
    <path
      d="M126.401 38.0749L128.914 30.8359H130.203V32.2807H129.762L127.991 38.0749H126.401ZM127.745 36.3191L128.116 35.1853H131.462L131.834 36.3191H127.745ZM131.618 38.0749L129.852 32.2807V30.8359H130.695L133.213 38.0749H131.618Z"
      fill="url(#paint6_linear_97_39825)"
    />
    <path
      d="M118.19 38.2586C117.491 38.2586 116.888 38.1048 116.379 37.7971C115.871 37.4894 115.48 37.0513 115.205 36.4828C114.931 35.9142 114.794 35.2386 114.794 34.456V34.446C114.794 33.6634 114.931 32.9878 115.205 32.4193C115.48 31.8508 115.869 31.4143 116.374 31.11C116.883 30.8023 117.488 30.6484 118.19 30.6484C118.762 30.6484 119.275 30.7605 119.73 30.9846C120.188 31.2086 120.558 31.518 120.839 31.9126C121.12 32.3073 121.284 32.7588 121.331 33.2671V33.3323H119.861L119.856 33.2972C119.806 33.0263 119.704 32.7889 119.55 32.5848C119.396 32.3775 119.202 32.217 118.968 32.1033C118.737 31.9895 118.478 31.9327 118.19 31.9327C117.812 31.9327 117.485 32.0347 117.207 32.2387C116.929 32.4394 116.715 32.7287 116.565 33.1066C116.418 33.4811 116.344 33.9276 116.344 34.446V34.456C116.344 34.9711 116.418 35.4176 116.565 35.7955C116.715 36.1734 116.929 36.4644 117.207 36.6684C117.485 36.8724 117.814 36.9744 118.195 36.9744C118.486 36.9744 118.745 36.9225 118.973 36.8189C119.204 36.7118 119.394 36.563 119.545 36.3724C119.699 36.1784 119.801 35.9527 119.851 35.6951L119.861 35.65H121.336V35.7102C121.282 36.2152 121.117 36.6583 120.839 37.0396C120.561 37.4209 120.197 37.7202 119.745 37.9376C119.294 38.1516 118.775 38.2586 118.19 38.2586Z"
      fill="url(#paint7_linear_97_39825)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_97_39825"
        x1="7.8687"
        y1="38.1129"
        x2="38.1136"
        y2="7.79582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F745D1" />
        <stop offset="0.481131" stopColor="#B405EC" />
        <stop offset="1" stopColor="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_97_39825"
        x1="41.1905"
        y1="18.4833"
        x2="29.6165"
        y2="30.5389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F84AC9" />
        <stop offset="0.499374" stopColor="#F030EA" />
        <stop offset="1" stopColor="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_97_39825"
        x1="21.2411"
        y1="10.9816"
        x2="2.73298"
        y2="30.7599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1500D9" />
        <stop offset="0.499374" stopColor="#294FCB" />
        <stop offset="1" stopColor="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_97_39825"
        x1="34.7514"
        y1="11.7804"
        x2="16.87"
        y2="30.4646"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B800EC" />
        <stop offset="0.456979" stopColor="#8F2EE6" />
        <stop offset="1" stopColor="#472CDA" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_97_39825"
        x1="114.224"
        y1="34.4488"
        x2="155.925"
        y2="34.4488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_97_39825"
        x1="114.224"
        y1="34.4469"
        x2="155.925"
        y2="34.4469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2765C2" />
        <stop offset="1" stopColor="#190DD7" />
      </linearGradient>
    </defs>
  </svg>
);

export const BeaconRedLogo = () => (
  <svg
    width="186"
    height="27"
    viewBox="0 0 186 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_922_18677)">
      <path
        d="M9.53329 22.8942H5.21354V19.2372H9.53329C11.3392 19.2372 12.2409 19.8482 12.2409 21.0658C12.2409 22.2853 11.3392 22.8942 9.53329 22.8942ZM5.21354 12.2352H8.75342C10.489 12.2352 11.3572 12.8107 11.3572 13.959C11.3572 15.1277 10.489 15.7116 8.75342 15.7116H5.21354V12.2352ZM16.563 18.8648C15.9724 18.1022 15.1561 17.5381 14.1166 17.1789C14.8968 16.7845 15.4987 16.2471 15.9247 15.5692C16.3508 14.8913 16.563 14.1242 16.563 13.2657C16.563 11.8228 15.9539 10.6769 14.7413 9.82721C13.526 8.97777 11.7562 8.55371 9.42945 8.55371H0.109375V26.5757H9.95052C12.3808 26.5757 14.236 26.1477 15.5211 25.2892C16.8063 24.4308 17.4489 23.2131 17.4489 21.632C17.4489 20.5504 17.1534 19.6298 16.563 18.8648Z"
        fill="#454B51"
      />
      <path
        d="M25.2311 22.5085V19.3421H33.3271V15.5314H25.2311V12.6212H34.4206V8.55371H20.1294V26.5757H34.7589V22.5085H25.2311Z"
        fill="#454B51"
      />
      <path
        d="M44.313 19.3151L46.6555 13.5487L48.9978 19.3151H44.313ZM49.2322 8.55371H44.1551L36.1113 26.5757H41.371L42.8025 23.0747H50.5083L51.9401 26.5757H57.3011L49.2322 8.55371Z"
        fill="#454B51"
      />
      <path
        d="M67.8452 22.7141C66.8558 22.7141 65.9743 22.4999 65.2032 22.0719C64.4298 21.6417 63.8324 21.0374 63.4061 20.2571C62.9801 19.4743 62.7681 18.5778 62.7681 17.5655C62.7681 16.553 62.9801 15.6567 63.4061 14.874C63.8324 14.0937 64.4298 13.4891 65.2032 13.0587C65.9743 12.6306 66.8558 12.4167 67.8452 12.4167C69.5294 12.4167 70.9612 13.119 72.1401 14.5259L75.4204 11.5914C74.5343 10.4944 73.4252 9.65162 72.0882 9.06715C70.7511 8.48533 69.2521 8.19336 67.5835 8.19336C65.6764 8.19336 63.963 8.59227 62.4435 9.39062C60.9242 10.189 59.7316 11.2994 58.8634 12.7243C57.9952 14.1495 57.5625 15.7637 57.5625 17.5655C57.5625 19.3671 57.9952 20.9816 58.8634 22.4065C59.7316 23.8314 60.9242 24.9418 62.4435 25.7402C63.963 26.5385 65.6764 26.9377 67.5835 26.9377C69.2521 26.9377 70.7511 26.6457 72.0882 26.0615C73.4252 25.4792 74.5343 24.6387 75.4204 23.5392L72.1401 20.6025C70.9612 22.0118 69.5294 22.7141 67.8452 22.7141Z"
        fill="#454B51"
      />
      <path
        d="M90.7802 20.2571C90.3451 21.0374 89.7547 21.6417 89.0083 22.0719C88.2621 22.5002 87.4301 22.7141 86.5103 22.7141C85.5904 22.7141 84.7562 22.5002 84.0101 22.0719C83.264 21.6417 82.6755 21.0374 82.2403 20.2571C81.8075 19.4743 81.591 18.5778 81.591 17.5655C81.591 16.553 81.8075 15.6567 82.2403 14.874C82.6755 14.0937 83.264 13.4893 84.0101 13.0589C84.7562 12.6306 85.5904 12.4167 86.5103 12.4167C87.4301 12.4167 88.2621 12.6306 89.0083 13.0589C89.7547 13.4893 90.3451 14.0937 90.7802 14.874C91.213 15.6567 91.4298 16.553 91.4298 17.5655C91.4298 18.5778 91.213 19.4743 90.7802 20.2571ZM95.321 12.7513C94.4462 11.3264 93.24 10.2115 91.7046 9.40412C90.1671 8.59677 88.4356 8.19336 86.5103 8.19336C84.5828 8.19336 82.8537 8.59677 81.3162 9.40412C79.7805 10.2115 78.5746 11.3264 77.6976 12.7513C76.823 14.176 76.3833 15.7793 76.3833 17.5655C76.3833 19.3518 76.823 20.9551 77.6976 22.38C78.5746 23.8047 79.7805 24.922 81.3162 25.7269C82.8537 26.534 84.5828 26.9377 86.5103 26.9377C88.4356 26.9377 90.1671 26.534 91.7046 25.7269C93.24 24.922 94.4462 23.8047 95.321 22.38C96.1978 20.9551 96.6375 19.3518 96.6375 17.5655C96.6375 15.7793 96.1978 14.176 95.321 12.7513Z"
        fill="#454B51"
      />
      <path
        d="M111.629 8.55371V18.1578L103.588 8.55371H99.3428V26.5757H104.393V16.9716L112.437 26.5757H116.682V8.55371H111.629Z"
        fill="#454B51"
      />
      <path
        d="M138.314 17.1657C137.775 17.6204 136.977 17.8478 135.917 17.8478H133.054V12.5698H135.917C136.977 12.5698 137.775 12.8017 138.314 13.2657C138.851 13.7271 139.121 14.3807 139.121 15.2211C139.121 16.0618 138.851 16.7106 138.314 17.1657ZM140.76 20.9118C141.905 20.3633 142.787 19.6028 143.402 18.6329C144.018 17.6628 144.327 16.5256 144.327 15.2211C144.327 13.8653 143.998 12.6858 143.337 11.6823C142.679 10.6767 141.741 9.90503 140.526 9.36318C139.311 8.82345 137.879 8.55371 136.231 8.55371H127.9V26.5757H133.054V21.7882H135.866L139.173 26.5757H144.692L140.76 20.9118Z"
        fill="#454B51"
      />
      <path
        d="M152.267 22.5085V19.3421H160.363V15.5314H152.267V12.6212H161.456V8.55371H147.165V26.5757H161.795V22.5085H152.267Z"
        fill="#454B51"
      />
      <path
        d="M179.923 12.8017C179.073 11.4462 177.876 10.3979 176.331 9.65992C174.785 8.92192 173.015 8.55371 171.02 8.55371H164.658V12.6212H170.812C172.373 12.6212 173.626 13.0582 174.573 13.9344C175.52 14.8087 175.991 16.0195 175.991 17.5648C175.991 19.1102 175.52 20.3186 174.573 21.195C173.626 22.0714 172.373 22.5085 170.812 22.5085H164.658V26.5757H171.02C173.015 26.5757 174.785 26.208 176.331 25.4697C177.876 24.7315 179.073 23.6835 179.923 22.3279C180.773 20.9721 181.199 19.3844 181.199 17.5648C181.199 15.7452 180.773 14.1575 179.923 12.8017Z"
        fill="#454B51"
      />
      <path
        d="M171.842 4.16083H185.797V0.145508H171.842V4.16083Z"
        fill="#FF5622"
      />
    </g>
    <defs>
      <clipPath id="clip0_922_18677">
        <rect width="186" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PoweredByCircleLogo = () => (
  <svg
    width="34"
    height="38"
    viewBox="0 0 45 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M43.0221 21.3663C43.0221 33.1666 33.456 42.7326 21.6557 42.7326C9.85546 42.7326 0.289429 33.1666 0.289429 21.3663C0.289429 9.56603 9.85546 0 21.6557 0C33.456 0 43.0221 9.56603 43.0221 21.3663Z"
      fill="url(#paint0_linear_97_39855)"
    />
    <path
      d="M36.7564 27.9286V14.3599C36.7564 12.2238 35.0552 10.4922 32.9566 10.4922C30.858 10.4922 29.1567 12.2238 29.1567 14.3599V23.5865C29.5156 23.2394 29.9917 22.9511 30.4602 23.114C30.7101 23.2009 30.9329 23.3693 31.0348 23.6659C31.196 24.1355 30.9406 24.631 30.7123 25.0707L29.6603 27.0965C29.6108 27.1917 29.5489 27.2796 29.4762 27.3578C29.2711 27.5787 29.1567 27.8711 29.1567 28.175V28.8673C29.1567 30.4849 30.4451 31.7963 32.0344 31.7963H32.9566C35.0552 31.7963 36.7564 30.0647 36.7564 27.9286Z"
      fill="#C3B8FF"
    />
    <path
      d="M23.0518 28.0583V14.2293C23.0518 12.0963 21.3227 10.3672 19.1897 10.3672C17.0567 10.3672 15.3275 12.0963 15.3275 14.2293V23.6147C15.6922 23.2636 16.179 22.9708 16.6567 23.1381C16.9127 23.2278 17.1401 23.4017 17.2409 23.7084C17.3949 24.1774 17.1426 24.6677 16.9142 25.1054L15.8393 27.1656C15.7891 27.262 15.726 27.3511 15.6518 27.4306C15.4434 27.6538 15.3275 27.9479 15.3275 28.2533V28.9492C15.3275 30.5902 16.6578 31.9205 18.2988 31.9205H19.1897C21.3227 31.9205 23.0518 30.1913 23.0518 28.0583Z"
      fill="#C3B8FF"
    />
    <path
      d="M36.3747 19.0866C37.8982 17.5631 40.3588 17.5538 41.8707 19.0656V19.0656C43.3826 20.5775 43.3732 23.0382 41.8497 24.5616L35.5109 30.9005C33.9874 32.4239 31.5268 32.4333 30.0149 30.9214V30.9214C28.503 29.4095 28.5124 26.9489 30.0359 25.4254L36.3747 19.0866Z"
      fill="url(#paint1_linear_97_39855)"
    />
    <path
      d="M16.4966 11.5309C18.0022 10.0253 20.4433 10.0253 21.949 11.5309V11.5309C23.4546 13.0366 23.4546 15.4777 21.949 16.9833L8.17871 30.7536C6.67306 32.2593 4.23192 32.2593 2.72627 30.7536V30.7536C1.22062 29.248 1.22062 26.8068 2.72627 25.3012L16.4966 11.5309Z"
      fill="url(#paint2_linear_97_39855)"
    />
    <path
      d="M30.0883 11.6706C31.6366 10.1223 34.1468 10.1223 35.6951 11.6706V11.6706C37.2434 13.2188 37.2434 15.7291 35.6951 17.2773L21.8542 31.1182C20.306 32.6665 17.7957 32.6665 16.2475 31.1182V31.1182C14.6992 29.57 14.6992 27.0597 16.2475 25.5115L30.0883 11.6706Z"
      fill="url(#paint3_linear_97_39855)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_97_39855"
        x1="7.8687"
        y1="38.1129"
        x2="38.1136"
        y2="7.79582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F745D1" />
        <stop offset="0.481131" stopColor="#B405EC" />
        <stop offset="1" stopColor="#2768C1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_97_39855"
        x1="41.1905"
        y1="18.4833"
        x2="29.6165"
        y2="30.5389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F84AC9" />
        <stop offset="0.499374" stopColor="#F030EA" />
        <stop offset="1" stopColor="#BF2FEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_97_39855"
        x1="21.2411"
        y1="10.9816"
        x2="2.73298"
        y2="30.7599"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1500D9" />
        <stop offset="0.499374" stopColor="#294FCB" />
        <stop offset="1" stopColor="#2669BF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_97_39855"
        x1="34.7514"
        y1="11.7804"
        x2="16.87"
        y2="30.4646"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B800EC" />
        <stop offset="0.456979" stopColor="#8F2EE6" />
        <stop offset="1" stopColor="#472CDA" />
      </linearGradient>
    </defs>
  </svg>
);

export const PoweredByLogo = () => (
  <svg
    width="34"
    height="38"
    viewBox="0 0 34 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="20.1521"
      cy="18.0169"
      r="10.0169"
      fill="url(#paint0_linear_371_8708)"
    />
    <path
      d="M27.2303 21.0924V14.7312C27.2303 13.7298 26.4328 12.918 25.4489 12.918C24.4651 12.918 23.6675 13.7298 23.6675 14.7312V19.0568C23.8357 18.894 24.0589 18.7589 24.2786 18.8353C24.3957 18.876 24.5002 18.9549 24.5479 19.094C24.6235 19.3141 24.5038 19.5465 24.3967 19.7526L23.9035 20.7023C23.8804 20.7469 23.8513 20.7882 23.8173 20.8248C23.7211 20.9284 23.6675 21.0655 23.6675 21.2079V21.5325C23.6675 22.2909 24.2715 22.9057 25.0166 22.9057H25.4489C26.4328 22.9057 27.2303 22.0938 27.2303 21.0924Z"
      fill="#9FF9E8"
    />
    <path
      d="M20.8053 21.1532V14.67C20.8053 13.67 19.9947 12.8594 18.9947 12.8594C17.9947 12.8594 17.1841 13.67 17.1841 14.67V19.07C17.355 18.9054 17.5833 18.7681 17.8072 18.8466C17.9272 18.8886 18.0338 18.9701 18.0811 19.1139C18.1533 19.3338 18.035 19.5637 17.928 19.7689L17.424 20.7347C17.4005 20.7799 17.3709 20.8217 17.3361 20.8589C17.2384 20.9636 17.1841 21.1015 17.1841 21.2446V21.5709C17.1841 22.3402 17.8077 22.9639 18.5771 22.9639H18.9947C19.9947 22.9639 20.8053 22.1532 20.8053 21.1532Z"
      fill="#849EFE"
    />
    <path
      d="M27.0525 16.9495C27.7667 16.2352 28.9203 16.2308 29.6291 16.9396C30.3379 17.6484 30.3335 18.802 29.6193 19.5162L26.6475 22.488C25.9333 23.2022 24.7797 23.2066 24.0709 22.4978C23.3621 21.789 23.3665 20.6354 24.0807 19.9212L27.0525 16.9495Z"
      fill="#10EAED"
    />
    <path
      d="M17.7336 13.407C18.4395 12.7011 19.5839 12.7011 20.2898 13.407C20.9957 14.1129 20.9957 15.2573 20.2898 15.9632L13.8341 22.4189C13.1282 23.1248 11.9838 23.1248 11.2779 22.4189C10.572 21.713 10.572 20.5686 11.2779 19.8627L17.7336 13.407Z"
      fill="url(#paint1_linear_371_8708)"
    />
    <g filter="url(#filter0_bd_371_8708)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5351 13.5768C17.3144 13.8769 17.1841 14.2474 17.1841 14.6484V19.0501C17.1875 19.0468 17.1909 19.0436 17.1943 19.0404L20.2826 15.9512C20.5939 15.6398 20.7682 15.2432 20.8053 14.8365V14.6484C20.8053 14.448 20.7728 14.2553 20.7127 14.0752C20.6259 13.8248 20.4825 13.5898 20.2826 13.3898C19.5755 12.6826 18.4291 12.6826 17.722 13.3898L17.5351 13.5768Z"
        fill="url(#paint2_linear_371_8708)"
      />
    </g>
    <path
      d="M24.1052 13.4744C24.831 12.7486 26.0079 12.7486 26.7337 13.4744C27.4596 14.2003 27.4596 15.3771 26.7337 16.103L20.2449 22.5918C19.519 23.3176 18.3422 23.3176 17.6163 22.5918C16.8905 21.8659 16.8905 20.6891 17.6163 19.9632L24.1052 13.4744Z"
      fill="url(#paint3_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4346 22.4111C20.6674 22.0995 20.8052 21.7127 20.8052 21.2938V16.7747C20.8017 16.778 20.7982 16.7814 20.7947 16.7847L17.6067 19.9613C17.2854 20.2815 17.1055 20.6893 17.0671 21.1076V21.2938C17.0671 21.552 17.1194 21.7979 17.2141 22.0216C17.305 22.2298 17.4358 22.4249 17.6067 22.5951C18.3366 23.3225 19.52 23.3225 20.2499 22.5951L20.4346 22.4111Z"
      fill="url(#paint4_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.8671 22.2998C27.0952 21.9967 27.23 21.6223 27.23 21.2171V16.7743C27.2265 16.7776 27.2229 16.7809 27.2194 16.7842L24.0315 19.9025C23.7102 20.2168 23.5303 20.6171 23.4919 21.0277V21.2171C23.4919 21.4227 23.5266 21.6203 23.5906 21.8048C23.6806 22.0543 23.8275 22.2884 24.0315 22.488C24.7614 23.2019 25.9448 23.2019 26.6747 22.488L26.8671 22.2998Z"
      fill="url(#paint5_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.96 13.6545C23.7391 13.958 23.6089 14.3317 23.6089 14.7358V19.2255C23.6123 19.2222 23.6158 19.2189 23.6193 19.2156L26.7574 16.0681C27.0737 15.7509 27.2508 15.3468 27.2886 14.9324V14.7358C27.2886 14.5615 27.2643 14.393 27.2191 14.2332C27.1346 13.9496 26.9807 13.6824 26.7574 13.4584C26.0389 12.7378 24.874 12.7378 24.1555 13.4584L23.96 13.6545Z"
      fill="url(#paint6_linear_371_8708)"
    />
    <defs>
      <filter
        id="filter0_bd_371_8708"
        x="-146.816"
        y="-151.141"
        width="331.621"
        height="334.191"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_371_8708"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_371_8708"
          result="effect2_dropShadow_371_8708"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_371_8708"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_371_8708"
        x1="13.6885"
        y1="25.8679"
        x2="27.8678"
        y2="11.6548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_371_8708"
        x1="19.9579"
        y1="13.1495"
        x2="11.2811"
        y2="22.4218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_371_8708"
        x1="18.9947"
        y1="12.8594"
        x2="17.1832"
        y2="18.497"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_371_8708"
        x1="24.9486"
        y1="14.6395"
        x2="19.3897"
        y2="20.8246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_371_8708"
        x1="17.9724"
        y1="19.6571"
        x2="20.8708"
        y2="22.0398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_371_8708"
        x1="25.3609"
        y1="23.0234"
        x2="26.952"
        y2="16.9921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_371_8708"
        x1="25.4487"
        y1="12.918"
        x2="23.5989"
        y2="18.927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const QueryIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.228 9C8.777 7.835 10.258 7 12 7C14.21 7 16 8.343 16 10C16 11.4 14.722 12.575 12.994 12.907C12.452 13.011 12 13.447 12 14M12 17H12.01M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const AdminIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.4854 18.864L19.4927 18.853L19.4814 18.8463C19.1137 18.629 18.7211 18.4619 18.3034 18.345C17.8856 18.228 17.4511 18.1695 17 18.1695C16.5489 18.1695 16.1144 18.228 15.6966 18.345C15.2789 18.4619 14.8863 18.629 14.5186 18.8463L14.5073 18.853L14.5146 18.864C14.7824 19.2657 15.1339 19.5878 15.5689 19.8305C16.0042 20.0732 16.4813 20.1945 17 20.1945C17.5187 20.1945 17.9958 20.0732 18.4311 19.8305C18.8661 19.5878 19.2176 19.2657 19.4854 18.864ZM11.5296 22.0454L11.5297 22.0454L11.5287 22.0451C9.34823 21.3793 7.55047 20.0311 6.13526 17.9999C4.72003 15.9686 4.0125 13.7294 4.0125 11.282V6.55703C4.0125 6.14297 4.13252 5.77054 4.37262 5.43937C4.61286 5.108 4.9234 4.86784 5.30447 4.71871C5.3045 4.71869 5.30453 4.71868 5.30456 4.71867L11.3042 2.4688C11.3042 2.46879 11.3043 2.46878 11.3043 2.46877C11.5363 2.38591 11.7682 2.34453 12 2.34453C12.2318 2.34453 12.4637 2.38591 12.6957 2.46877C12.6957 2.46878 12.6958 2.46879 12.6958 2.4688L18.6954 4.71867C18.6955 4.71868 18.6955 4.71869 18.6955 4.71871C19.0766 4.86784 19.3871 5.108 19.6274 5.43937C19.8675 5.77054 19.9875 6.14297 19.9875 6.55703V10.8382C19.676 10.7076 19.3564 10.5891 19.0289 10.4826C18.6982 10.3752 18.3595 10.2964 18.0125 10.2462V6.58203V6.57337L18.0044 6.57033L12.0044 4.32033L12.0058 4.3165L11.9956 4.32033L5.99561 6.57033L5.9875 6.57337V6.58203V11.282C5.9875 12.0665 6.09182 12.8509 6.30042 13.6352C6.50899 14.4195 6.801 15.1662 7.17645 15.8754C7.55192 16.5846 8.00666 17.2396 8.54066 17.8403C9.07372 18.44 9.66504 18.9401 10.3146 19.3403C10.498 19.8729 10.7313 20.3723 11.0143 20.8385C11.2929 21.2974 11.6198 21.7161 11.9949 22.0945H11.7625C11.6894 22.0945 11.6118 22.0783 11.5296 22.0454ZM17 17.1945C17.4199 17.1945 17.7773 17.0474 18.0713 16.7534C18.3654 16.4593 18.5125 16.102 18.5125 15.682C18.5125 15.2621 18.3654 14.9047 18.0713 14.6107C17.7773 14.3167 17.4199 14.1695 17 14.1695C16.5801 14.1695 16.2227 14.3167 15.9287 14.6107C15.6346 14.9047 15.4875 15.2621 15.4875 15.682C15.4875 16.102 15.6346 16.4593 15.9287 16.7534C16.2227 17.0474 16.5801 17.1945 17 17.1945ZM17 22.1695C15.62 22.1695 14.444 21.6833 13.4713 20.7107C12.4987 19.738 12.0125 18.5621 12.0125 17.182C12.0125 15.802 12.4987 14.626 13.4713 13.6534C14.444 12.6807 15.62 12.1945 17 12.1945C18.38 12.1945 19.556 12.6807 20.5287 13.6534C21.5013 14.626 21.9875 15.802 21.9875 17.182C21.9875 18.5621 21.5013 19.738 20.5287 20.7107C19.556 21.6833 18.38 22.1695 17 22.1695Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const AdminIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 16.9984C17.4167 16.9984 17.7708 16.8526 18.0625 16.5609C18.3542 16.2693 18.5 15.9151 18.5 15.4984C18.5 15.0818 18.3542 14.7276 18.0625 14.4359C17.7708 14.1443 17.4167 13.9984 17 13.9984C16.5833 13.9984 16.2292 14.1443 15.9375 14.4359C15.6458 14.7276 15.5 15.0818 15.5 15.4984C15.5 15.9151 15.6458 16.2693 15.9375 16.5609C16.2292 16.8526 16.5833 16.9984 17 16.9984ZM17 19.9984C17.5167 19.9984 17.9917 19.8776 18.425 19.6359C18.8583 19.3943 19.2083 19.0734 19.475 18.6734C19.1083 18.4568 18.7167 18.2901 18.3 18.1734C17.8833 18.0568 17.45 17.9984 17 17.9984C16.55 17.9984 16.1167 18.0568 15.7 18.1734C15.2833 18.2901 14.8917 18.4568 14.525 18.6734C14.7917 19.0734 15.1417 19.3943 15.575 19.6359C16.0083 19.8776 16.4833 19.9984 17 19.9984ZM17 21.9984C15.6167 21.9984 14.4375 21.5109 13.4625 20.5359C12.4875 19.5609 12 18.3818 12 16.9984C12 15.6151 12.4875 14.4359 13.4625 13.4609C14.4375 12.4859 15.6167 11.9984 17 11.9984C18.3833 11.9984 19.5625 12.4859 20.5375 13.4609C21.5125 14.4359 22 15.6151 22 16.9984C22 18.3818 21.5125 19.5609 20.5375 20.5359C19.5625 21.5109 18.3833 21.9984 17 21.9984ZM12 21.9234H11.7625C11.6875 21.9234 11.6083 21.9068 11.525 21.8734C9.34167 21.2068 7.54167 19.8568 6.125 17.8234C4.70833 15.7901 4 13.5484 4 11.0984V6.37344C4 5.95677 4.12083 5.58177 4.3625 5.24844C4.60417 4.9151 4.91667 4.67344 5.3 4.52344L11.3 2.27344C11.5333 2.1901 11.7667 2.14844 12 2.14844C12.2333 2.14844 12.4667 2.1901 12.7 2.27344L18.7 4.52344C19.0833 4.67344 19.3958 4.9151 19.6375 5.24844C19.8792 5.58177 20 5.95677 20 6.37344V10.6734C19.5167 10.4568 19.0292 10.2901 18.5375 10.1734C18.0458 10.0568 17.5333 9.99844 17 9.99844C15.0667 9.99844 13.4167 10.6818 12.05 12.0484C10.6833 13.4151 10 15.0651 10 16.9984C10 17.9484 10.1667 18.8359 10.5 19.6609C10.8333 20.4859 11.3417 21.2401 12.025 21.9234H12Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const HomeIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M5.5 19.1836V19.6836H6H9H9.5V19.1836V13.6836H14.5V19.1836V19.6836H15H18H18.5V19.1836V10.1836V9.93359L18.3 9.78359L12.3 5.28359L12 5.05859L11.7 5.28359L5.7 9.78359L5.5 9.93359V10.1836V19.1836ZM4.66 9.50762L4.66042 9.50678C4.76701 9.2931 4.91128 9.12203 5.09568 8.9868L5.0957 8.98682L5.1 8.98359L11.0969 4.48593C11.241 4.38155 11.3862 4.30689 11.5331 4.25794C11.6807 4.20873 11.8356 4.18359 12 4.18359C12.1644 4.18359 12.3193 4.20873 12.4669 4.25794C12.6138 4.30689 12.759 4.38154 12.9031 4.48592L18.9 8.98359L18.9 8.98362L18.9043 8.9868C19.0888 9.1221 19.2335 9.29334 19.3408 9.50728C19.4474 9.72113 19.5 9.94457 19.5 10.1836V19.1836C19.5 19.5998 19.3578 19.9439 19.0597 20.2428C18.7607 20.5413 18.4164 20.6836 18 20.6836H13.5V15.1836V14.6836H13H11H10.5V15.1836V20.6836H6C5.58354 20.6836 5.23978 20.5413 4.94155 20.243C4.64248 19.944 4.5 19.5998 4.5 19.1836V10.1836C4.5 9.94477 4.55282 9.72148 4.66 9.50762ZM4.213 9.28359C4.35433 9.00026 4.55 8.76693 4.8 8.58359L4.213 9.28359Z"
      stroke="#637E85"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V18C14 18.5304 14.2107 19.0391 14.5858 19.4142C14.9609 19.7893 15.4696 20 16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858Z"
      className="svgicon stroke"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashboardIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V8C4 8.53043 4.21071 9.03914 4.58579 9.41421C4.96086 9.78929 5.46957 10 6 10H8C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 4.58579C14.2107 4.96086 14 5.46957 14 6V8C14 8.53043 14.2107 9.03914 14.5858 9.41421C14.9609 9.78929 15.4696 10 16 10H18C18.5304 10 19.0391 9.78929 19.4142 9.41421C19.7893 9.03914 20 8.53043 20 8V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H16C15.4696 4 14.9609 4.21071 14.5858 4.58579Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58579 14.5858C4.21071 14.9609 4 15.4696 4 16V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V16C10 15.4696 9.78929 14.9609 9.41421 14.5858C9.03914 14.2107 8.53043 14 8 14H6C5.46957 14 4.96086 14.2107 4.58579 14.5858Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16V18C14 18.5304 14.2107 19.0391 14.5858 19.4142C14.9609 19.7893 15.4696 20 16 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V16C20 15.4696 19.7893 14.9609 19.4142 14.5858C19.0391 14.2107 18.5304 14 18 14H16C15.4696 14 14.9609 14.2107 14.5858 14.5858Z"
      className="svgicon-primary stroke fill"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ParticipantIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    className="side-bar-icon"
  >
    <path
      d="M40-272q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v32q0 33-23.5 56.5T600-160H120q-33 0-56.5-23.5T40-240v-32Zm800 112H738q11-18 16.5-38.5T760-240v-40q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v40q0 33-23.5 56.5T840-160ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
      className="svgicon fill stroke"
    />
  </svg>
);

export const ParticipantIconActive = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 20C1.71667 20 1.47933 19.904 1.288 19.712C1.096 19.5207 1 19.2833 1 19V17.2C1 16.6333 1.146 16.1123 1.438 15.637C1.72933 15.1623 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6457 5.75 13.387C6.81667 13.129 7.9 13 9 13C10.1 13 11.1833 13.129 12.25 13.387C13.3167 13.6457 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2707 15.1623 16.562 15.637C16.854 16.1123 17 16.6333 17 17.2V19C17 19.2833 16.904 19.5207 16.712 19.712C16.5207 19.904 16.2833 20 16 20H2ZM18.525 20C18.675 19.8833 18.7917 19.7373 18.875 19.562C18.9583 19.3873 19 19.1917 19 18.975V17C19 16.2667 18.796 15.5623 18.388 14.887C17.9793 14.2123 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4207 19.05 13.662C19.8 13.904 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.254 22.525 15.662C22.8417 16.0707 23 16.5167 23 17V19C23 19.2833 22.904 19.5207 22.712 19.712C22.5207 19.904 22.2833 20 22 20H18.525ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9793 14.3 11.938C14.0167 11.896 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3957 10.675 14.637 10.025C14.879 9.375 15 8.7 15 8C15 7.3 14.879 6.625 14.637 5.975C14.3957 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.06233 14.3 4.037C14.5333 4.01233 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const StudyBuilderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const StudyBuilderIconActive = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      strokeWidth="0.025"
      className="svgicon-primary fill stroke"
    />
  </svg>
);

export const StudySettingsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
    <path
      d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);
export const StudySettingsIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7881 3.80244C13.3321 1.93044 10.6681 1.93044 10.2121 3.80244C10.144 4.08374 10.0105 4.34499 9.82236 4.56493C9.63424 4.78487 9.39685 4.95729 9.1295 5.06816C8.86216 5.17903 8.57242 5.22521 8.28386 5.20294C7.99529 5.18068 7.71606 5.0906 7.46889 4.94004C5.82249 3.93684 3.93849 5.82084 4.94169 7.46724C5.58969 8.53044 5.01489 9.91764 3.80529 10.2116C1.93209 10.6664 1.93209 13.3316 3.80529 13.7852C4.08666 13.8534 4.34796 13.9871 4.5679 14.1753C4.78785 14.3636 4.96022 14.6011 5.07098 14.8686C5.18174 15.1361 5.22776 15.426 5.20529 15.7146C5.18283 16.0033 5.09251 16.2825 4.94169 16.5296C3.93849 18.176 5.82249 20.06 7.46889 19.0568C7.71602 18.906 7.99527 18.8157 8.28391 18.7932C8.57255 18.7708 8.86242 18.8168 9.12991 18.9276C9.39739 19.0383 9.63494 19.2107 9.8232 19.4306C10.0115 19.6506 10.1451 19.9119 10.2133 20.1932C10.6681 22.0664 13.3333 22.0664 13.7869 20.1932C13.8553 19.912 13.9891 19.6509 14.1774 19.4311C14.3657 19.2113 14.6032 19.039 14.8706 18.9283C15.138 18.8176 15.4278 18.7715 15.7163 18.7939C16.0049 18.8162 16.2841 18.9063 16.5313 19.0568C18.1777 20.06 20.0617 18.176 19.0585 16.5296C18.9079 16.2825 18.8178 16.0032 18.7955 15.7147C18.7732 15.4261 18.8192 15.1363 18.93 14.8689C19.0407 14.6015 19.213 14.364 19.4328 14.1757C19.6525 13.9874 19.9137 13.8536 20.1949 13.7852C22.0681 13.3304 22.0681 10.6652 20.1949 10.2116C19.9135 10.1435 19.6522 10.0098 19.4323 9.82155C19.2123 9.63329 19.04 9.39574 18.9292 9.12825C18.8184 8.86077 18.7724 8.5709 18.7949 8.28226C18.8174 7.99362 18.9077 7.71437 19.0585 7.46724C20.0617 5.82084 18.1777 3.93684 16.5313 4.94004C16.2842 5.09085 16.0049 5.18117 15.7163 5.20364C15.4276 5.22611 15.1378 5.18009 14.8703 5.06932C14.6028 4.95856 14.3652 4.78619 14.177 4.56625C13.9887 4.34631 13.8551 4.08501 13.7869 3.80364L13.7881 3.80244ZM12.0001 15.5984C12.9549 15.5984 13.8705 15.2192 14.5457 14.544C15.2208 13.8689 15.6001 12.9532 15.6001 11.9984C15.6001 11.0437 15.2208 10.128 14.5457 9.45285C13.8705 8.77772 12.9549 8.39844 12.0001 8.39844C11.0453 8.39844 10.1296 8.77772 9.45451 9.45285C8.77938 10.128 8.40009 11.0437 8.40009 11.9984C8.40009 12.9532 8.77938 13.8689 9.45451 14.544C10.1296 15.2192 11.0453 15.5984 12.0001 15.5984Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const AuditTrailIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V16M5 21L9.879 16.121M9.879 16.121C10.1567 16.4033 10.4876 16.6279 10.8525 16.7817C11.2174 16.9355 11.6092 17.0156 12.0052 17.0173C12.4012 17.0189 12.7936 16.9421 13.1599 16.7914C13.5261 16.6406 13.8588 16.4188 14.1388 16.1388C14.4189 15.8588 14.6408 15.5262 14.7916 15.16C14.9425 14.7938 15.0193 14.4014 15.0177 14.0054C15.0162 13.6094 14.9362 13.2176 14.7825 12.8526C14.6287 12.4877 14.4043 12.1568 14.122 11.879C13.5579 11.3239 12.7973 11.0142 12.0059 11.0173C11.2145 11.0204 10.4564 11.3362 9.8967 11.8957C9.33702 12.4553 9.02111 13.2133 9.0178 14.0047C9.01448 14.7961 9.32402 15.5568 9.879 16.121Z"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon stroke"
      strokeLinejoin="round"
    />
  </svg>
);
export const MahaloIcon = () => (
  <svg
    width="35"
    height="31"
    viewBox="0 0 52 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M49.3315 25.5C49.3315 39.031 38.3625 50 24.8315 50C11.3005 50 0.331482 39.031 0.331482 25.5C0.331482 11.969 11.3005 1 24.8315 1C38.3625 1 49.3315 11.969 49.3315 25.5Z"
      fill="url(#paint0_linear_79_793)"
    />
    <path
      d="M42.1431 33.024V17.4652C42.1431 15.0159 40.1924 13.0303 37.786 13.0303C35.3796 13.0303 33.4288 15.0159 33.4288 17.4652V28.0451C33.8404 27.647 34.3862 27.3164 34.9235 27.5033C35.21 27.6029 35.4655 27.796 35.5823 28.1362C35.7671 28.6745 35.4744 29.2428 35.2125 29.747L34.0062 32.0698C33.9495 32.179 33.8785 32.2798 33.7952 32.3695C33.5599 32.6227 33.4288 32.958 33.4288 33.3065V34.1003C33.4288 35.9552 34.9061 37.4589 36.7285 37.4589H37.786C40.1924 37.4589 42.1431 35.4733 42.1431 33.024Z"
      fill="#9FF9E8"
    />
    <path
      d="M26.4289 33.174V17.3168C26.4289 14.8709 24.4462 12.8882 22.0003 12.8882C19.5545 12.8882 17.5717 14.8709 17.5717 17.3168V28.0786C17.9899 27.676 18.5481 27.3403 19.0959 27.5322C19.3894 27.635 19.6501 27.8344 19.7657 28.1861C19.9424 28.7239 19.653 29.2861 19.3912 29.7879L18.1586 32.1503C18.101 32.2608 18.0286 32.363 17.9436 32.4541C17.7046 32.7102 17.5717 33.0473 17.5717 33.3975V34.1955C17.5717 36.0772 19.0971 37.6026 20.9788 37.6026H22.0003C24.4462 37.6026 26.4289 35.6198 26.4289 33.174Z"
      fill="#849EFE"
    />
    <path
      d="M41.7084 22.8911C43.4553 21.1442 46.2768 21.1334 48.0104 22.867C49.744 24.6007 49.7333 27.4222 47.9864 29.1691L40.7178 36.4376C38.9709 38.1845 36.1494 38.1953 34.4158 36.4616C32.6822 34.728 32.6929 31.9065 34.4398 30.1596L41.7084 22.8911Z"
      fill="#10EAED"
    />
    <path
      d="M18.9161 14.2242C20.6426 12.4977 23.4418 12.4977 25.1682 14.2242C26.8947 15.9507 26.8947 18.7498 25.1682 20.4763L9.37833 36.2662C7.65186 37.9927 4.85269 37.9927 3.12622 36.2662C1.39974 34.5397 1.39974 31.7406 3.12622 30.0141L18.9161 14.2242Z"
      fill="url(#paint1_linear_79_793)"
    />
    <g filter="url(#filter0_bd_79_793)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4302 14.643C17.8906 15.3768 17.5717 16.2831 17.5717 17.2638V28.0299C17.58 28.022 17.5884 28.014 17.5967 28.0061L25.1503 20.4504C25.9117 19.6888 26.3379 18.7188 26.4289 17.724V17.2638C26.4289 16.7739 26.3493 16.3025 26.2024 15.8619C25.9899 15.2496 25.6392 14.6747 25.1503 14.1857C23.4209 12.4557 20.6168 12.4557 18.8874 14.1856L18.4302 14.643Z"
        fill="url(#paint2_linear_79_793)"
      />
    </g>
    <path
      d="M34.5009 14.3884C36.2762 12.613 39.1546 12.613 40.9299 14.3884C42.7053 16.1637 42.7053 19.0421 40.9299 20.8175L25.0591 36.6883C23.2837 38.4636 20.4053 38.4636 18.63 36.6883C16.8547 34.913 16.8547 32.0346 18.63 30.2592L34.5009 14.3884Z"
      fill="url(#paint3_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5226 36.247C26.0919 35.4847 26.429 34.5388 26.429 33.5142V22.461C26.4205 22.4691 26.4119 22.4773 26.4033 22.4854L18.606 30.255C17.82 31.0382 17.38 32.0356 17.2861 33.0587V33.5142C17.2861 34.1457 17.4142 34.7472 17.6457 35.2943C17.8679 35.8036 18.188 36.2806 18.606 36.6971C20.3912 38.476 23.2857 38.476 25.071 36.6971L25.5226 36.247Z"
      fill="url(#paint4_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.2555 35.9747C41.8134 35.2334 42.143 34.3176 42.143 33.3264V22.46C42.1345 22.4681 42.1258 22.4762 42.1171 22.4842L34.32 30.1111C33.534 30.8799 33.0941 31.859 33.0001 32.8632V33.3264C33.0001 33.8293 33.085 34.3128 33.2415 34.764C33.4616 35.3741 33.8211 35.9469 34.32 36.4349C36.1052 38.1812 38.9997 38.1812 40.785 36.4349L41.2555 35.9747Z"
      fill="url(#paint5_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1444 14.8318C33.6044 15.5742 33.2858 16.4881 33.2858 17.4764V28.4577C33.2942 28.4496 33.3027 28.4415 33.3112 28.4334L40.9866 20.7351C41.7603 19.9592 42.1934 18.9709 42.2858 17.9573V17.4764C42.2858 17.0502 42.2266 16.6379 42.1159 16.2472C41.9092 15.5536 41.5328 14.9 40.9866 14.3522C39.2292 12.5896 36.38 12.5896 34.6226 14.3522L34.1444 14.8318Z"
      fill="url(#paint6_linear_79_793)"
    />
    <defs>
      <filter
        id="filter0_bd_79_793"
        x="-146.428"
        y="-151.112"
        width="336.857"
        height="343.142"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_79_793"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_79_793"
          result="effect2_dropShadow_79_793"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_79_793"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_79_793"
        x1="9.02236"
        y1="44.7027"
        x2="43.7031"
        y2="9.93919"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_79_793"
        x1="24.3565"
        y1="13.5943"
        x2="3.13391"
        y2="36.2734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_79_793"
        x1="22.0003"
        y1="12.8882"
        x2="17.5695"
        y2="26.6771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_79_793"
        x1="36.5639"
        y1="17.238"
        x2="22.9675"
        y2="32.3661"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_79_793"
        x1="19.5004"
        y1="29.511"
        x2="26.5894"
        y2="35.3388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_79_793"
        x1="37.5716"
        y1="37.7446"
        x2="41.4631"
        y2="22.9926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_79_793"
        x1="37.7858"
        y1="13.0303"
        x2="33.2613"
        y2="27.7277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const FoodIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.725024 18.2661C0.541691 18.0828 0.450024 17.8494 0.450024 17.5661C0.450024 17.2828 0.541691 17.0494 0.725024 16.8661L10.275 7.31609C9.97502 6.61609 9.93336 5.82442 10.15 4.94109C10.3667 4.05775 10.8417 3.26609 11.575 2.56609C12.4584 1.68275 13.4417 1.16609 14.525 1.01609C15.6084 0.866086 16.4917 1.13275 17.175 1.81609C17.8584 2.49942 18.125 3.38275 17.975 4.46609C17.825 5.54942 17.3084 6.53275 16.425 7.41609C15.725 8.14942 14.9334 8.62442 14.05 8.84109C13.1667 9.05775 12.375 9.01609 11.675 8.71609L10.425 9.96609L17.325 16.8661C17.5084 17.0494 17.6 17.2828 17.6 17.5661C17.6 17.8494 17.5084 18.0828 17.325 18.2661C17.125 18.4661 16.8917 18.5661 16.625 18.5661C16.3584 18.5661 16.125 18.4661 15.925 18.2661L9.02502 11.4161L2.12502 18.2661C1.92502 18.4661 1.69169 18.5661 1.42502 18.5661C1.15836 18.5661 0.925024 18.4661 0.725024 18.2661ZM4.37502 10.4161L1.37502 7.41609C0.625024 6.66609 0.187524 5.79109 0.0625244 4.79109C-0.0624756 3.79109 0.125024 2.84942 0.625024 1.96609C0.791691 1.68275 1.04169 1.52442 1.37502 1.49109C1.70836 1.45775 2.00002 1.57442 2.25002 1.84109L7.57502 7.21609L4.37502 10.4161Z"
      fill="#637E85"
      className="svgicon fill"
    />
  </svg>
);

export const ExerciseIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M15.9036 17.4871L16.2571 17.1336L15.9036 16.78L7.40355 8.28004L7.05 7.92649L6.69645 8.28004L3.84645 11.13C3.73761 11.2389 3.63569 11.2747 3.51624 11.2709L3.51499 11.2708C3.38388 11.2669 3.26942 11.2209 3.15355 11.105C3.04446 10.9959 3 10.8843 3 10.7456C3 10.6079 3.0442 10.4965 3.15355 10.3871L2.8 10.0336L3.15355 10.3871L3.85355 9.68715L4.20711 9.33359L3.85355 8.98004L3.15355 8.28004L2.80436 8.62923L3.15355 8.28004C3.04101 8.1675 3 8.05898 3 7.93359C3 7.8082 3.04101 7.69969 3.15355 7.58715L2.80593 7.23952L3.15355 7.58715L4.57855 6.16215L4.93211 5.80859L4.57855 5.45504L3.85355 4.73004C3.74823 4.62471 3.70856 4.51954 3.71275 4.38632L3.71279 4.38515C3.71695 4.24209 3.76583 4.12487 3.87855 4.01215C3.98765 3.90305 4.09927 3.85859 4.238 3.85859C4.37457 3.85859 4.48525 3.90206 4.59373 4.00944L5.2903 4.73089L5.64374 5.09696L6.00355 4.73715L7.40355 3.33715L7.05593 2.98952L7.40355 3.33715C7.5161 3.2246 7.62461 3.18359 7.75 3.18359C7.87539 3.18359 7.9839 3.2246 8.09645 3.33715L8.45 2.98359L8.09645 3.33715L8.82145 4.06215L9.175 4.4157L9.52855 4.06215L10.2536 3.33715C10.334 3.25674 10.4357 3.20859 10.6 3.20859C10.7643 3.20859 10.866 3.25674 10.9464 3.33715C11.0268 3.41755 11.075 3.51932 11.075 3.68359C11.075 3.84786 11.0268 3.94964 10.9464 4.03004L8.09645 6.88004L7.74289 7.23359L8.09645 7.58715L16.5964 16.0871L16.95 16.4407L17.3036 16.0871L20.1536 13.2371C20.2626 13.1281 20.3743 13.0836 20.513 13.0836C20.6507 13.0836 20.7621 13.1278 20.8714 13.2371C20.9808 13.3465 21.025 13.4579 21.025 13.5956C21.025 13.7343 20.9805 13.8459 20.8714 13.955L20.1464 14.68L19.7929 15.0336L20.1464 15.3871L20.8464 16.0871C20.959 16.1997 21 16.3082 21 16.4336C21 16.559 20.959 16.6675 20.8464 16.78L19.4214 18.205L19.0679 18.5586L19.4214 18.9121L20.1464 19.6371C20.259 19.7497 20.3 19.8582 20.3 19.9836C20.3 20.109 20.259 20.2175 20.1464 20.33C20.0371 20.4394 19.9257 20.4836 19.788 20.4836C19.6493 20.4836 19.5376 20.4391 19.4286 20.33L19.4286 20.33L19.4223 20.3239L18.6973 19.6239L18.3439 19.2826L17.9964 19.63L16.5964 21.03C16.4839 21.1426 16.3754 21.1836 16.25 21.1836C16.1246 21.1836 16.0161 21.1426 15.9036 21.03L15.1786 20.305L14.825 19.9515L14.4714 20.305L13.7464 21.03C13.666 21.1104 13.5643 21.1586 13.4 21.1586C13.2357 21.1586 13.134 21.1104 13.0536 21.03C12.9732 20.9496 12.925 20.8479 12.925 20.6836C12.925 20.5193 12.9732 20.4175 13.0536 20.3371L15.9036 17.4871Z"
      className="svgicon fill stroke"
    />
  </svg>
);

export const MedicationIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M8.625 21.1836C7.05833 21.1836 5.72933 20.6379 4.638 19.5466C3.546 18.4546 3 17.1253 3 15.5586C3 14.8086 3.14167 14.0919 3.425 13.4086C3.70833 12.7253 4.11667 12.1169 4.65 11.5836L11.4 4.83359C11.9333 4.30026 12.5417 3.89193 13.225 3.60859C13.9083 3.32526 14.625 3.18359 15.375 3.18359C16.9417 3.18359 18.271 3.72926 19.363 4.82059C20.4543 5.91259 21 7.24193 21 8.80859C21 9.55859 20.8583 10.2753 20.575 10.9586C20.2917 11.6419 19.8833 12.2503 19.35 12.7836L12.6 19.5336C12.0667 20.0669 11.4583 20.4753 10.775 20.7586C10.0917 21.0419 9.375 21.1836 8.625 21.1836ZM15.275 14.0336L17.95 11.3836C18.2833 11.0503 18.5417 10.6586 18.725 10.2086C18.9083 9.75859 19 9.29193 19 8.80859C19 7.80859 18.646 6.95426 17.938 6.24559C17.2293 5.53759 16.375 5.18359 15.375 5.18359C14.8917 5.18359 14.425 5.27526 13.975 5.45859C13.525 5.64193 13.1333 5.90026 12.8 6.23359L10.15 8.90859L15.275 14.0336ZM8.625 19.1836C9.10833 19.1836 9.575 19.0919 10.025 18.9086C10.475 18.7253 10.8667 18.4669 11.2 18.1336L13.85 15.4586L8.725 10.3336L6.05 12.9836C5.71667 13.3169 5.45833 13.7086 5.275 14.1586C5.09167 14.6086 5 15.0753 5 15.5586C5 16.5586 5.354 17.4129 6.062 18.1216C6.77067 18.8296 7.625 19.1836 8.625 19.1836Z"
      className="svgicon fill"
    />
  </svg>
);

export const ModulesIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 11.1726H14.9875V11.1851V13.1851C14.9875 13.4652 14.8929 13.6995 14.7037 13.8887C14.5145 14.0779 14.2802 14.1726 14 14.1726C13.7198 14.1726 13.4855 14.0779 13.2963 13.8887C13.1071 13.6995 13.0125 13.4652 13.0125 13.1851V11.1851V11.1726H13H11C10.7198 11.1726 10.4855 11.0779 10.2963 10.8887C10.1071 10.6995 10.0125 10.4652 10.0125 10.1851C10.0125 9.90487 10.1071 9.6706 10.2963 9.4814C10.4855 9.29219 10.7198 9.19756 11 9.19756H13H13.0125V9.18506V7.18506C13.0125 6.90487 13.1071 6.6706 13.2963 6.4814C13.4855 6.29219 13.7198 6.19756 14 6.19756C14.2802 6.19756 14.5145 6.29219 14.7037 6.4814C14.8929 6.6706 14.9875 6.90487 14.9875 7.18506V9.18506V9.19756H15H17C17.2802 9.19756 17.5145 9.29219 17.7037 9.4814C17.8929 9.6706 17.9875 9.90487 17.9875 10.1851C17.9875 10.4652 17.8929 10.6995 17.7037 10.8887C17.5145 11.0779 17.2802 11.1726 17 11.1726H15ZM7.9875 16.1851V16.1976H8H20H20.0125V16.1851V4.18506V4.17256H20H8H7.9875V4.18506V16.1851ZM3.9875 20.1851V20.1976H4H17C17.2802 20.1976 17.5145 20.2922 17.7037 20.4814C17.8929 20.6706 17.9875 20.9049 17.9875 21.1851C17.9875 21.4652 17.8929 21.6995 17.7037 21.8887C17.5145 22.0779 17.2802 22.1726 17 22.1726H4C3.45334 22.1726 2.98568 21.9781 2.59634 21.5887C2.207 21.1994 2.0125 20.7317 2.0125 20.1851V7.18506C2.0125 6.90487 2.10713 6.6706 2.29634 6.4814C2.48555 6.29219 2.71981 6.19756 3 6.19756C3.28019 6.19756 3.51445 6.29219 3.70366 6.4814C3.89287 6.6706 3.9875 6.90487 3.9875 7.18506V20.1851ZM8 18.1726C7.45334 18.1726 6.98568 17.9781 6.59634 17.5887C6.207 17.1994 6.0125 16.7317 6.0125 16.1851V4.18506C6.0125 3.6384 6.207 3.17074 6.59634 2.7814C6.98568 2.39206 7.45334 2.19756 8 2.19756H20C20.5467 2.19756 21.0143 2.39206 21.4037 2.7814C21.793 3.17074 21.9875 3.6384 21.9875 4.18506V16.1851C21.9875 16.7317 21.793 17.1994 21.4037 17.5887C21.0143 17.9781 20.5467 18.1726 20 18.1726H8Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const ModulesIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14 14C14.2833 14 14.5208 13.9042 14.7125 13.7125C14.9042 13.5208 15 13.2833 15 13V11H17C17.2833 11 17.5208 10.9042 17.7125 10.7125C17.9042 10.5208 18 10.2833 18 10C18 9.71667 17.9042 9.47917 17.7125 9.2875C17.5208 9.09583 17.2833 9 17 9H15V7C15 6.71667 14.9042 6.47917 14.7125 6.2875C14.5208 6.09583 14.2833 6 14 6C13.7167 6 13.4792 6.09583 13.2875 6.2875C13.0958 6.47917 13 6.71667 13 7V9H11C10.7167 9 10.4792 9.09583 10.2875 9.2875C10.0958 9.47917 10 9.71667 10 10C10 10.2833 10.0958 10.5208 10.2875 10.7125C10.4792 10.9042 10.7167 11 11 11H13V13C13 13.2833 13.0958 13.5208 13.2875 13.7125C13.4792 13.9042 13.7167 14 14 14ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V7C2 6.71667 2.09583 6.47917 2.2875 6.2875C2.47917 6.09583 2.71667 6 3 6C3.28333 6 3.52083 6.09583 3.7125 6.2875C3.90417 6.47917 4 6.71667 4 7V20H17C17.2833 20 17.5208 20.0958 17.7125 20.2875C17.9042 20.4792 18 20.7167 18 21C18 21.2833 17.9042 21.5208 17.7125 21.7125C17.5208 21.9042 17.2833 22 17 22H4Z"
      className="svgicon-primary fill"
    />
  </svg>
);

export const TrackingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.9875 10.275H12.976L12.9935 10.2857C13.2919 10.468 13.5321 10.7042 13.7144 10.9942C13.8964 11.2836 13.9875 11.6187 13.9875 12C13.9875 12.5467 13.793 13.0143 13.4037 13.4037C13.0143 13.793 12.5467 13.9875 12 13.9875C11.4533 13.9875 10.9857 13.793 10.5963 13.4037C10.207 13.0143 10.0125 12.5467 10.0125 12C10.0125 11.6188 10.1036 11.2794 10.2857 10.9815C10.4679 10.6833 10.708 10.4515 11.0061 10.2859L11.0125 10.2975V10.275V8.125V8.10869L10.9967 8.11293C10.1275 8.34696 9.40855 8.8193 8.84024 9.52969C8.27174 10.2403 7.9875 11.0639 7.9875 12C7.9875 13.1033 8.3805 14.0482 9.16616 14.8338C9.95182 15.6195 10.8967 16.0125 12 16.0125C13.1033 16.0125 14.0482 15.6195 14.8338 14.8338C15.6195 14.0482 16.0125 13.1033 16.0125 12C16.0125 11.5655 15.9498 11.1641 15.8243 10.796C15.699 10.4283 15.5277 10.0774 15.3105 9.74319L15.3105 9.74318L15.3102 9.74273C15.1451 9.5117 15.071 9.25618 15.0875 8.97573C15.104 8.69514 15.2029 8.4648 15.3838 8.28384C15.5816 8.08611 15.8159 7.9875 16.0875 7.9875C16.3583 7.9875 16.5754 8.10205 16.7398 8.33227L16.74 8.33245C17.1226 8.84813 17.4262 9.41373 17.6508 10.0293C17.8752 10.6445 17.9875 11.3014 17.9875 12C17.9875 13.6634 17.4055 15.0769 16.2412 16.2412C15.0769 17.4055 13.6634 17.9875 12 17.9875C10.3366 17.9875 8.92313 17.4055 7.75884 16.2412C6.59454 15.0769 6.0125 13.6634 6.0125 12C6.0125 10.5029 6.48649 9.20164 7.43449 8.09563C8.38258 6.98953 9.5716 6.32019 11.002 6.08734L11.0125 6.08563V6.075V4.05V4.03583L10.9984 4.0376C9.01209 4.28798 7.34684 5.16444 6.00318 6.66667C4.65942 8.16901 3.9875 9.94699 3.9875 12C3.9875 14.2366 4.76377 16.1314 6.31616 17.6838C7.86855 19.2362 9.76342 20.0125 12 20.0125C14.2366 20.0125 16.1314 19.2362 17.6838 17.6838C19.2362 16.1314 20.0125 14.2366 20.0125 12C20.0125 11.0319 19.8539 10.118 19.5367 9.25817C19.2196 8.39851 18.7689 7.6181 18.1846 6.917L18.1845 6.91693C18.0031 6.70251 17.9125 6.45537 17.9125 6.175C17.9125 5.89498 18.0112 5.65649 18.2088 5.45884C18.4065 5.2612 18.6407 5.16677 18.9121 5.17499C19.1835 5.18322 19.4093 5.29402 19.5905 5.50807L19.5905 5.50809C20.3396 6.39034 20.9263 7.38079 21.3508 8.47951C21.7753 9.57798 21.9875 10.7514 21.9875 12C21.9875 13.3817 21.7253 14.68 21.201 15.895C20.6766 17.1103 19.965 18.1673 19.0662 19.0662C18.1673 19.965 17.1103 20.6766 15.895 21.201C14.68 21.7253 13.3817 21.9875 12 21.9875C10.6183 21.9875 9.31999 21.7253 8.10495 21.201C6.88968 20.6766 5.83268 19.965 4.93384 19.0662C4.035 18.1673 3.32338 17.1103 2.79898 15.895C2.27468 14.68 2.0125 13.3817 2.0125 12C2.0125 10.6183 2.27468 9.31999 2.79898 8.10495C3.32338 6.88968 4.035 5.83268 4.93384 4.93384C5.83268 4.035 6.88968 3.32338 8.10495 2.79898C9.31999 2.27468 10.6183 2.0125 12 2.0125C12.2802 2.0125 12.5145 2.10713 12.7037 2.29634C12.8929 2.48555 12.9875 2.71981 12.9875 3V10.275Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const TrackingIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3V10.275C13.3 10.4583 13.5417 10.6958 13.725 10.9875C13.9083 11.2792 14 11.6167 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.6167 10.0917 11.275 10.275 10.975C10.4583 10.675 10.7 10.4417 11 10.275V8.125C10.1333 8.35833 9.41667 8.82917 8.85 9.5375C8.28333 10.2458 8 11.0667 8 12C8 13.1 8.39167 14.0417 9.175 14.825C9.95833 15.6083 10.9 16 12 16C13.1 16 14.0417 15.6083 14.825 14.825C15.6083 14.0417 16 13.1 16 12C16 11.5667 15.9375 11.1667 15.8125 10.8C15.6875 10.4333 15.5167 10.0833 15.3 9.75C15.1333 9.51667 15.0583 9.25833 15.075 8.975C15.0917 8.69167 15.1917 8.45833 15.375 8.275C15.575 8.075 15.8125 7.975 16.0875 7.975C16.3625 7.975 16.5833 8.09167 16.75 8.325C17.1333 8.84167 17.4375 9.40833 17.6625 10.025C17.8875 10.6417 18 11.3 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18C10.3333 18 8.91667 17.4167 7.75 16.25C6.58333 15.0833 6 13.6667 6 12C6 10.5 6.475 9.19583 7.425 8.0875C8.375 6.97917 9.56667 6.30833 11 6.075V4.05C9.01667 4.3 7.35417 5.175 6.0125 6.675C4.67083 8.175 4 9.95 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.0333 19.8417 10.1208 19.525 9.2625C19.2083 8.40417 18.7583 7.625 18.175 6.925C17.9917 6.70833 17.9 6.45833 17.9 6.175C17.9 5.89167 18 5.65 18.2 5.45C18.4 5.25 18.6375 5.15417 18.9125 5.1625C19.1875 5.17083 19.4167 5.28333 19.6 5.5C20.35 6.38333 20.9375 7.375 21.3625 8.475C21.7875 9.575 22 10.75 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
      fill="#327091"
      className="svgicon-primary fill"
    />
  </svg>
);

export const AppointmentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8 7V3M16 7V3M7 11H17M5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21Z"
      // stroke="#674F82"
      strokeWidth="2"
      className="svgicon stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AppointmentsIconActive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.99844 5.30039H6.49844V4.80039V3.60039C6.49844 3.41474 6.57219 3.23669 6.70346 3.10542C6.83474 2.97414 7.01279 2.90039 7.19844 2.90039C7.38409 2.90039 7.56214 2.97414 7.69341 3.10542C7.82469 3.23669 7.89844 3.41474 7.89844 3.60039V4.80039V5.30039H8.39844H15.5984H16.0984V4.80039V3.60039C16.0984 3.41474 16.1722 3.23669 16.3035 3.10542C16.4347 2.97414 16.6128 2.90039 16.7984 2.90039C16.9841 2.90039 17.1621 2.97414 17.2934 3.10542C17.4247 3.23669 17.4984 3.41474 17.4984 3.60039V4.80039V5.30039H17.9984H19.1984C19.7023 5.30039 20.1856 5.50057 20.5419 5.85689C20.8983 6.21321 21.0984 6.69648 21.0984 7.20039V19.2004C21.0984 19.7043 20.8983 20.1876 20.5419 20.5439C20.1856 20.9002 19.7023 21.1004 19.1984 21.1004H4.79844C4.29453 21.1004 3.81125 20.9002 3.45493 20.5439C3.09862 20.1876 2.89844 19.7043 2.89844 19.2004V7.20039C2.89844 6.69648 3.09862 6.21321 3.45493 5.85689C3.81125 5.50057 4.29453 5.30039 4.79844 5.30039H5.99844ZM5.99636 10.8025L6.32634 10.4725L5.99636 10.8025C6.31517 11.1213 6.74757 11.3004 7.19844 11.3004H16.7984C17.2493 11.3004 17.6817 11.1213 18.0005 10.8025C18.3193 10.4837 18.4984 10.0513 18.4984 9.60039C18.4984 9.14952 18.3193 8.71712 18.0005 8.39831C17.6817 8.0795 17.2493 7.90039 16.7984 7.90039H7.19844C6.74757 7.90039 6.31517 8.0795 5.99636 8.39831C5.67754 8.71712 5.49844 9.14952 5.49844 9.60039C5.49844 10.0513 5.67754 10.4837 5.99636 10.8025Z"
      fill="#1B0ED8"
      stroke="#1B0ED8"
      className="svgicon-primary stroke fill"
    />
  </svg>
);

export const MessagesIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10.9661H8.01M12 10.9661H12.01M16 10.9661H16.01M9 16.9661H5C4.46957 16.9661 3.96086 16.7554 3.58579 16.3803C3.21071 16.0052 3 15.4965 3 14.9661V6.96609C3 6.43566 3.21071 5.92695 3.58579 5.55188C3.96086 5.17681 4.46957 4.96609 5 4.96609H19C19.5304 4.96609 20.0391 5.17681 20.4142 5.55188C20.7893 5.92695 21 6.43566 21 6.96609V14.9661C21 15.4965 20.7893 16.0052 20.4142 16.3803C20.0391 16.7554 19.5304 16.9661 19 16.9661H14L9 21.9661V16.9661Z"
      stroke="#637E85"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const MessagesIconActive = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5984 6.0001V15.6001C21.5984 16.2366 21.3456 16.8471 20.8955 17.2972C20.4454 17.7472 19.835 18.0001 19.1984 18.0001H13.1984L7.19844 22.8001V18.0001H4.79844C4.16192 18.0001 3.55147 17.7472 3.10138 17.2972C2.65129 16.8471 2.39844 16.2366 2.39844 15.6001V6.0001C2.39844 5.36358 2.65129 4.75313 3.10138 4.30304C3.55147 3.85295 4.16192 3.6001 4.79844 3.6001H19.1984C19.835 3.6001 20.4454 3.85295 20.8955 4.30304C21.3456 4.75313 21.5984 5.36358 21.5984 6.0001ZM8.39844 9.6001H5.99844V12.0001H8.39844V9.6001ZM10.7984 9.6001H13.1984V12.0001H10.7984V9.6001ZM17.9984 9.6001H15.5984V12.0001H17.9984V9.6001Z"
      fill="#1B0ED8"
      className="svgicon-primary fill"
    />
  </svg>
);

export const FeaturesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7122 15.4975L10.7217 15.4955L10.7048 15.4885C10.5051 15.4053 10.3179 15.3179 10.1433 15.2264C9.96891 15.1351 9.79026 15.0229 9.60735 14.8899L9.61229 14.8831L9.59629 14.8881L8.87132 15.1131C8.65731 15.1789 8.45198 15.1706 8.25481 15.0885C8.05723 15.0061 7.90093 14.8745 7.78564 14.6934C7.78561 14.6934 7.78558 14.6933 7.78555 14.6933L7.5608 14.3187C7.56078 14.3187 7.56075 14.3186 7.56073 14.3186C7.44552 14.121 7.40446 13.9114 7.43737 13.6893C7.47022 13.4675 7.57688 13.2828 7.75792 13.1347L7.75817 13.1345L8.30817 12.6595L8.31513 12.6675L8.31237 12.6482C8.27911 12.4154 8.2625 12.1993 8.2625 12C8.2625 11.8007 8.27911 11.5846 8.31237 11.3518L8.32292 11.3533L8.30817 11.3405L7.75817 10.8655L7.75817 10.8655L7.75792 10.8653C7.57699 10.7173 7.47026 10.5284 7.43737 10.2982C7.40443 10.0676 7.44558 9.85382 7.5608 9.6563L7.56085 9.6562L7.7607 9.30646C7.8759 9.12554 8.03625 8.99396 8.24214 8.91161C8.44779 8.82935 8.65736 8.82111 8.87132 8.88695L9.59629 9.11194L9.5938 9.11996L9.60735 9.11011C9.79026 8.97708 9.96891 8.86492 10.1433 8.77357C10.3179 8.68209 10.5051 8.59474 10.7048 8.51154L10.7084 8.52026L10.7122 8.50262L10.8622 7.80262C10.9117 7.57186 11.0228 7.38264 11.1956 7.23449C11.3683 7.08646 11.5696 7.0125 11.8 7.0125H12.2C12.4306 7.0125 12.6319 7.08242 12.8046 7.22222C12.9773 7.36197 13.0883 7.54689 13.1378 7.7776C13.1378 7.7776 13.1378 7.77761 13.1378 7.77762L13.2878 8.50253L13.2783 8.50449L13.2952 8.51154C13.4949 8.59474 13.6821 8.68209 13.8567 8.77357C14.0311 8.86492 14.2097 8.97708 14.3926 9.11011L14.3877 9.1169L14.4037 9.11194L15.1287 8.88695C15.3427 8.8211 15.548 8.82938 15.7452 8.91154C15.9428 8.99387 16.0991 9.12547 16.2144 9.30658C16.2144 9.30663 16.2144 9.30667 16.2145 9.30671L16.4392 9.6813C16.4392 9.68131 16.4392 9.68131 16.4392 9.68132C16.5545 9.87891 16.5955 10.0885 16.5626 10.3107C16.5298 10.5325 16.4231 10.7172 16.2421 10.8653L16.2418 10.8655L15.6918 11.3405L15.6849 11.3325L15.6876 11.3518C15.7209 11.5846 15.7375 11.8007 15.7375 12C15.7375 12.1993 15.7209 12.4154 15.6876 12.6482L15.6771 12.6467L15.6918 12.6595L16.2418 13.1345L16.2421 13.1347C16.423 13.2827 16.5297 13.4716 16.5626 13.7018C16.5956 13.9324 16.5544 14.1462 16.4392 14.3437L16.4391 14.3438L16.2395 14.6933C16.2394 14.6934 16.2393 14.6935 16.2393 14.6935C16.1241 14.8745 15.9638 15.006 15.7579 15.0884C15.5522 15.1707 15.3426 15.1789 15.1287 15.1131L14.4037 14.8881L14.4062 14.88L14.3926 14.8899C14.2097 15.0229 14.0311 15.1351 13.8567 15.2264C13.6821 15.3179 13.4949 15.4053 13.2952 15.4885L13.2916 15.4797L13.2878 15.4974L13.1378 16.1974C13.0883 16.4281 12.9772 16.6174 12.8044 16.7655C12.6317 16.9135 12.4304 16.9875 12.2 16.9875H11.8C11.5694 16.9875 11.3681 16.9176 11.1954 16.7778C11.0227 16.638 10.9117 16.4531 10.8622 16.2224C10.8622 16.2224 10.8622 16.2224 10.8622 16.2224L10.7122 15.4975ZM4.9875 19V19.0125H5H19H19.0125V19V5V4.9875H19H5H4.9875V5V19ZM10.5787 13.4213C10.9727 13.8153 11.4467 14.0125 12 14.0125C12.5533 14.0125 13.0273 13.8153 13.4213 13.4213C13.8153 13.0273 14.0125 12.5533 14.0125 12C14.0125 11.4467 13.8153 10.9727 13.4213 10.5787C13.0273 10.1847 12.5533 9.9875 12 9.9875C11.4467 9.9875 10.9727 10.1847 10.5787 10.5787C10.1847 10.9727 9.9875 11.4467 9.9875 12C9.9875 12.5533 10.1847 13.0273 10.5787 13.4213ZM5 20.9875C4.45334 20.9875 3.98568 20.793 3.59634 20.4037C3.207 20.0143 3.0125 19.5467 3.0125 19V5C3.0125 4.45334 3.207 3.98568 3.59634 3.59634C3.98568 3.207 4.45334 3.0125 5 3.0125H19C19.5467 3.0125 20.0143 3.207 20.4037 3.59634C20.793 3.98568 20.9875 4.45334 20.9875 5V19C20.9875 19.5467 20.793 20.0143 20.4037 20.4037C20.0143 20.793 19.5467 20.9875 19 20.9875H5Z"
      fill="#637E85"
      stroke="#637E85"
      strokeWidth="0.025"
    />
  </svg>
);

export const PlatformUsersIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17.0004C17.4167 17.0004 17.7708 16.8546 18.0625 16.5629C18.3542 16.2712 18.5 15.9171 18.5 15.5004C18.5 15.0837 18.3542 14.7296 18.0625 14.4379C17.7708 14.1462 17.4167 14.0004 17 14.0004C16.5833 14.0004 16.2292 14.1462 15.9375 14.4379C15.6458 14.7296 15.5 15.0837 15.5 15.5004C15.5 15.9171 15.6458 16.2712 15.9375 16.5629C16.2292 16.8546 16.5833 17.0004 17 17.0004ZM17 20.0004C17.5167 20.0004 17.9917 19.8796 18.425 19.6379C18.8583 19.3962 19.2083 19.0754 19.475 18.6754C19.1083 18.4587 18.7167 18.2921 18.3 18.1754C17.8833 18.0587 17.45 18.0004 17 18.0004C16.55 18.0004 16.1167 18.0587 15.7 18.1754C15.2833 18.2921 14.8917 18.4587 14.525 18.6754C14.7917 19.0754 15.1417 19.3962 15.575 19.6379C16.0083 19.8796 16.4833 20.0004 17 20.0004ZM17 22.0004C15.6167 22.0004 14.4375 21.5129 13.4625 20.5379C12.4875 19.5629 12 18.3837 12 17.0004C12 15.6171 12.4875 14.4379 13.4625 13.4629C14.4375 12.4879 15.6167 12.0004 17 12.0004C18.3833 12.0004 19.5625 12.4879 20.5375 13.4629C21.5125 14.4379 22 15.6171 22 17.0004C22 18.3837 21.5125 19.5629 20.5375 20.5379C19.5625 21.5129 18.3833 22.0004 17 22.0004ZM12 21.9254H11.7625C11.6875 21.9254 11.6083 21.9087 11.525 21.8754C9.34167 21.2087 7.54167 19.8587 6.125 17.8254C4.70833 15.7921 4 13.5504 4 11.1004V6.37539C4 5.95872 4.12083 5.58372 4.3625 5.25039C4.60417 4.91706 4.91667 4.67539 5.3 4.52539L11.3 2.27539C11.5333 2.19206 11.7667 2.15039 12 2.15039C12.2333 2.15039 12.4667 2.19206 12.7 2.27539L18.7 4.52539C19.0833 4.67539 19.3958 4.91706 19.6375 5.25039C19.8792 5.58372 20 5.95872 20 6.37539V10.6754C19.6833 10.5421 19.3583 10.4212 19.025 10.3129C18.6917 10.2046 18.35 10.1254 18 10.0754V6.40039L12 4.15039L6 6.40039V11.1004C6 11.8837 6.10417 12.6671 6.3125 13.4504C6.52083 14.2337 6.8125 14.9796 7.1875 15.6879C7.5625 16.3962 8.01667 17.0504 8.55 17.6504C9.08333 18.2504 9.675 18.7504 10.325 19.1504C10.5083 19.6837 10.7417 20.1837 11.025 20.6504C11.3083 21.1171 11.6417 21.5421 12.025 21.9254H12Z"
      fill="#637E85"
    />
  </svg>
);

export const AllStudiesIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      fill="#637E85"
      stroke="#637E85"
      strokeWidth="0.025"
    />
  </svg>
);
